<h1 mat-dialog-title *ngIf="moreDetails">More Details</h1>
<div mat-dialog-content>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12" *ngIf="moreDetails">
        <div class="width-100" *ngFor="let item of moreDetails?.searchTerms; let i = index">
          <div class="width-100">
            <span value="key"> Search Term: </span>
            <span value="value">
              <strong>{{ item.searchTerm }}</strong>
            </span>
            <span value="key"> Search Index: </span>
            <span value="value">
              <strong>{{ item.searchIndex }}</strong>
            </span>
            <span value="key"> Phrase Type: </span>
            <span value="value">
              <strong>{{ item.queryOption }}</strong>
            </span>
            <span value="key"> Operator: </span>
            <span value="value">
              <strong>{{ item.operator }}</strong>
            </span>
          </div>
          <div class="width-100" *ngIf="i === 0">
            <div class="width-100" *ngFor="let l of moreDetails?.libraries">
              <span value="key"> Libraries: </span>
              <span value="value">
                <strong>{{ l }}</strong>
              </span>
            </div>
            <div class="width-100" *ngFor="let y of moreDetails?.yearOfPub">
              <span value="key"> Year of Publication: </span>
              <span value="value">
                <strong> {{ y }}</strong>
              </span>
            </div>
            <div class="width-100" *ngFor="let f of moreDetails?.formats">
              <span value="key"> Formats: </span>
              <span value="value">
                <strong> {{ f }}</strong>
              </span>
            </div>
            <div class="width-100" *ngFor="let a of moreDetails?.audiences">
              <span value="key"> Audience Level: </span>
              <span value="value">
                <strong> {{ a }}</strong>
              </span>
            </div>
            <div class="width-100" *ngFor="let r of moreDetails?.resources">
              <span value="key"> Resource(s): </span>
              <span value="value">
                <strong> {{ r }}</strong>
              </span>
            </div>
            <div class="width-100" *ngIf="moreDetails?.dateItemsAdded">
              <span value="key"> Date of Item Added: </span>
              <span value="value">
                <strong> {{ moreDetails?.dateItemsAdded }}</strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    role="button"
    type="button"
    aria-label="Close"
    class="btn btn-primary"
    cdkFocusInitial
    (click)="close()"
  >
    Close
  </button>
</div>
